export const GET_VENUE = "GET_VENUE";
